/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyTypeCardIcon16Light = forwardRef('MoneyTypeCardIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.5 6a.5.5 0 1 1 0-1h2a.5.5 0 1 1 0 1h-2Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 5.5A2.5 2.5 0 0 1 3.5 3h8A2.5 2.5 0 0 1 14 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 1 10.5v-5Zm12 0V9H2V5.5A1.5 1.5 0 0 1 3.5 4h8A1.5 1.5 0 0 1 13 5.5Zm-11 5V10h11v.5a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 2 10.5Z" })));
});
